module.exports = "https://de18y2hs3hlxs.cloudfront.net/d7023bab-6786-4218-a639-f7331314cecc/images/LogoHorizontal_White.svg?9c112b852f8360595639d7074f825d62";